import { useEffect, useState } from "react";
import { Copy, Check, FileText, AlertTriangle } from "lucide-react";
import { toast } from "sonner";

const EMAIL_FILE = "/docs/SAFUAYE_Response_CharityCommission_Oct2026_Email.txt";

const DOCS = [
  { id: "letter-en", file: "SAFUAYE_Response_CharityCommission_Oct2026_EN.pdf", title: "Lettre de réponse (EN)", badge: "À ENVOYER", desc: "Réponse officielle point par point" },
  { id: "declaration-signed", file: "SAFUAYE_Trustee_Declaration_SIGNED.pdf", title: "Trustee Declaration signée (3 pages)", badge: "À ENVOYER", desc: "Signée à l'encre par Kokou, Yao et Ablavi — exemplaires séparés" },
  { id: "constitution-en", file: "SAFUAYE_Constitution_CIO_EN_SIGNED.pdf", title: "Constitution CIO signée (EN)", badge: "À ENVOYER", desc: "18 pages — page 16 signée par Kokou, Yao et Ablavi (exemplaires séparés)" },
  { id: "letter-fr", file: "SAFUAYE_Reponse_CharityCommission_Oct2026_FR.pdf", title: "Traduction FR de la réponse", badge: "INFORMATIF", desc: "Pour les trustees — ne pas envoyer" },
];

const STEPS = [
  "Toutes les signatures sont réunies (constitution + déclaration).",
  "Répondre au mail du 19/10 (Corey Jones) depuis association@safuaye.org en collant le texte ci-dessous.",
  "Joindre : constitution signée + Trustee Declaration signée (3 pages) + lettre EN.",
  "Envoyer avant le 09/11/2026.",
];

export const CharityCommissionResponse = () => {
  const [email, setEmail] = useState("");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    fetch(EMAIL_FILE).then((r) => r.text()).then(setEmail).catch(() => setEmail(""));
  }, []);

  const copy = async () => {
    await navigator.clipboard.writeText(email);
    setCopied(true);
    toast.success("Texte du mail copié");
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="bg-amber-50 border border-amber-300 rounded-xl p-4 mb-4" data-testid="cc-response-oct2026">
      <div className="flex items-start gap-2 mb-3">
        <AlertTriangle className="w-5 h-5 text-amber-700 mt-0.5 shrink-0" />
        <p className="text-sm text-gray-800">
          Mail du <strong>19/10/2026</strong> (Corey Jones, réf. <strong>5289867 / CRM26:018000000138</strong>) : objets, intérêt public, trustees, constitution.
          Réponse à envoyer <strong data-testid="cc-response-deadline">avant le 09/11/2026</strong>.
        </p>
      </div>
      <ol className="list-decimal ml-6 text-xs text-gray-700 space-y-1 mb-4" data-testid="cc-response-steps">
        {STEPS.map((s) => <li key={s}>{s}</li>)}
      </ol>
      <div className="grid md:grid-cols-2 gap-3 mb-4">
        {DOCS.map((d) => (
          <a key={d.id} href={`/docs/${d.file}`} download data-testid={`cc-response-download-${d.id}`}
            className="bg-white rounded-lg p-3 border border-amber-200 hover:border-amber-400 hover:shadow-sm transition-shadow flex items-start gap-3">
            <FileText className="w-5 h-5 text-red-600 mt-0.5 shrink-0" />
            <span>
              <span className="font-semibold text-gray-900 text-sm flex flex-wrap items-center gap-2">
                {d.title}
                <span className="text-[10px] bg-amber-700 text-white px-2 py-0.5 rounded">{d.badge}</span>
              </span>
              <span className="block text-xs text-gray-500">{d.desc}</span>
            </span>
          </a>
        ))}
      </div>
      <div className="bg-white rounded-lg border border-amber-200">
        <div className="flex items-center justify-between px-3 py-2 border-b border-amber-100">
          <span className="text-sm font-semibold text-gray-900">Texte du mail (anglais) — prêt à copier-coller</span>
          <button onClick={copy} disabled={!email} data-testid="cc-response-copy-email-btn"
            className="inline-flex items-center gap-1 bg-amber-700 hover:bg-amber-800 disabled:opacity-50 text-white px-3 py-1.5 rounded-md text-xs font-medium transition-colors">
            {copied ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />} {copied ? "Copié" : "Copier"}
          </button>
        </div>
        <pre className="text-xs text-gray-700 whitespace-pre-wrap p-3 max-h-72 overflow-y-auto font-sans" data-testid="cc-response-email-text">
          {email || "Chargement…"}
        </pre>
      </div>
    </div>
  );
};
